<template>
	<div :class="[setClass,setOffset,setPush,setPull]">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'bsf-col',
		components: {},
		props: {
			size: {
				type: [String, Array],
				default: "md"
			},
			
			col: {
				type: String,
				default: "12"
			},
			offset: {
				type: String,
			},
			push: {
				type: String,
			},
			pull: {
				type: String
			}
		},
		data() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {})
		},
		computed: {
			setClass: function() {
				return "col-" + this.size + "-" + this.col
			},
			setOffset: function() {
				if(this.offset != undefined) {
					return "col-" + this.size + "-offset-" + this.offset
				}
			},
			setPush: function() {
				if(this.push != undefined) {
					return "col-" + this.size + "-push-" + this.push
				}
			},
			setPull: function() {
				if(this.pull != undefined) {
					return "col-" + this.size + "-pull-" + this.pull
				}
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
</style>


// WEBPACK FOOTER //
// col.vue?252013ba